import { Observable } from 'rxjs';
import { NgFor, NgIf } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { maskitoTransform } from '@maskito/core';
import { Component, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { mask_porcentagem_limpa } from '../../directives/mascaras';
import { TipoEtapaEnsinoSimcaqDto, TipoTurnoDto } from '../../dtos';
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { TabelaComponent } from '../../shared/tabela/tabela.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MediaHorasEtapasSimcaqDto } from '../../dtos/media-horas-etapas.dto';
import { PQRCargaHorarioEnsinoDto } from '../../dtos/pqr-carga-horaria-ensino.dto';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { CondicaoQualidadeStateService, EtapasDeEdicaoService } from '../../services';
import { MenuSuspensoComponent } from '../../shared/menu-suspenso/menu-suspenso.component';
import { RodapeFonteNotaComponent } from '../../shared/rodape-fonte-nota/rodape-fonte-nota.component';
import { MediaHorasEtapasSimcaqService } from '../../services/media-horas-etapas/media-horas-etapas.service';
import { DialogPqrPadraoCargaHorariaComponent } from '../../shared/dialog-pqr-padrao-carga-horaria/dialog-pqr-padrao-carga-horaria.component';
import { ValidacaoResult, ValidadorTela } from '../../interfaces/validacao.interface';
import { BasePqrComponent } from '../base-pqr/base-pqr.component';
import { AnosReferenciasService } from '../../services/anos-referencias/anos-referencias.service';
import { AnosReferenciasDto } from '../../dtos/anos-referencias.dto';
import { FeatureFlagService } from '../../services/feature-flag/feature-flag.service';

export interface DadosTabelaCargaHoraria {
  etapa: TipoEtapaEnsinoSimcaqDto;
  turnos: TipoTurnoDto[];
  medias: string[];
  pqr: number[]
}

@Component({
  selector: 'app-carga-horaria-de-ensino',
  standalone: true,
  imports: [
    FormsModule,
    MatIconModule,
    MatDialogModule,
    MatTooltipModule,
    ReactiveFormsModule,
    TabelaComponent,
    NgFor,
    NgIf,
    MenuSuspensoComponent,
    RodapeFonteNotaComponent
  ],
  templateUrl: './carga-horaria-de-ensino.component.html',
  styleUrl: './carga-horaria-de-ensino.component.scss',
})
export class CargaHorariaDeEnsinoComponent extends BasePqrComponent<PQRCargaHorarioEnsinoDto> implements ValidadorTela {
  protected valoresPadrao: PQRCargaHorarioEnsinoDto[] = [];
  protected valoresEdicao: PQRCargaHorarioEnsinoDto[] = [];
  anosReferencias: AnosReferenciasDto | null = null;
  anoCenso: number;

  dadosTabela: DadosTabelaCargaHoraria[] = [];
  mediaHorasEtapasEnsino: MediaHorasEtapasSimcaqDto[] = [];

  catalogoEtapa: any = {
    '1': {
      id: 1,
      descricao: 'Creche'
    },
    '2': {
      id: 1,
      descricao: 'Pré-Escola'
    },
    '3': {
      id: 1,
      descricao: 'Ensino Fundamental - anos iniciais'
    },
    '4': {
      id: 1,
      descricao: 'Ensino Fundamental - anos finais'
    },
    '5':
    {
      id: 1,
      descricao: 'Ensino Médio'
    },
    '6': {
      id: 1,
      descricao: 'EJA'
    }
  };

  constructor(
    router: Router,
    toastr: ToastrService,
    dialogRestaurarValores: MatDialog,
    private dialogPqrPadraoCargaHoraria: MatDialog,
    private etapasDeEdicaoService: EtapasDeEdicaoService,
    private condicaoQualidadeStateService: CondicaoQualidadeStateService,
    private mediaHorasEtapasSimcaqService: MediaHorasEtapasSimcaqService,
    private anosReferenciasService: AnosReferenciasService,
    private featureFlagService: FeatureFlagService
  ) {
    super(router, toastr, dialogRestaurarValores, dialogPqrPadraoCargaHoraria);
    if (this.featureFlagService.funcionalidadeHabilitada('940-atualizacao-de-componentes-de-edicao-pqr')) {
      this.anosReferencias = this.anosReferenciasService.obterAnosReferenciasSnapshot();
    }
    this.anoCenso = this.anosReferencias?.anoCenso ?? 2025;
  }

  async ngOnInit() {
    this.etapasDeEdicaoService.setOpcaoAtual(6);

    if (this.condicaoQualidadeStateService.carregando.getValue()) {
      this.condicaoQualidadeStateService.carregando.subscribe(async () => {
        this.carregarDadosInterno();
        return;
      });
    }

    this.carregarDadosInterno();
  }

  private carregarDadosInterno() {
    this.carregarDados(
      () => this.condicaoQualidadeStateService.getPQRCargaHorarioEnsinoPadrao(),
      () => this.condicaoQualidadeStateService.getPQRCargaHorarioEnsinoValores()
    );
    this.processarDadosTabela(this.valoresEdicao);
  }

  async carregueMediaHorasEtapasSimcaq() {
    this.mediaHorasEtapasEnsino = await this.mediaHorasEtapasSimcaqService.buscarMediaHorasEtapasSimcaq() ?? [];
  }

  private processarDadosTabela(cargaHorariaEnsino: PQRCargaHorarioEnsinoDto[]) {
    this.dadosTabela = [];
    if (!cargaHorariaEnsino || cargaHorariaEnsino.length === 0) return;

    const agrupamentoPorEtapaEnsino = cargaHorariaEnsino.reduce(
      (acumulador: Record<number, PQRCargaHorarioEnsinoDto[]>, item) => {
        const cod = item.etapaEnsino?.codEtapaEnsino;
        if (cod == null) return acumulador;
        (acumulador[cod] ||= []).push(item);
        return acumulador;
      },
      {}
    );

    Object.keys(agrupamentoPorEtapaEnsino).forEach((etapa) => {
      const valoresPorEtapa = agrupamentoPorEtapaEnsino[+etapa];

      const dadoTabela: DadosTabelaCargaHoraria = {
        etapa: valoresPorEtapa[0].etapaEnsino,
        medias: [],
        pqr: [],
        turnos: [],
      };

      valoresPorEtapa.forEach((item) => {

        if (!item?.tipoTurno) return;
        dadoTabela.pqr.push(item.qntCargaHorariaDiaria ?? 0);

        dadoTabela.turnos.push(item.tipoTurno);
      });

      this.dadosTabela.push(dadoTabela);
    });
  }


  public override restaurarValoresPadrao(): void {
    super.restaurarValoresPadrao();
    this.processarDadosTabela(this.valoresEdicao);
  }

  atualizarDadosDoServicoDeEstado() {
    let indice: number = 0;
    const dadosPQR: PQRCargaHorarioEnsinoDto[] = this.dadosTabela.flatMap(tabela => {
      const dto: PQRCargaHorarioEnsinoDto[] = tabela.turnos.map((turno, index) => {
        return {
          etapaEnsino: tabela.etapa,
          tipoTurno: turno,
          qntCargaHorariaDiaria: tabela.pqr[index],
          codPqrCargaHorariaEnsino: ++indice
        }
      });

      return dto;
    });
    this.valoresEdicao = dadosPQR;
    this.atualizarValores();
  }

  protected atualizarValores() {
    this.condicaoQualidadeStateService.setPQRCargaHorarioEnsinoValores(this.valoresEdicao);
  }

  protected openDialogPqrValoresPadrao() {
    const dialogRef = this.dialogPqrPadraoCargaHoraria.open(
      DialogPqrPadraoCargaHorariaComponent,
      { panelClass: 'dialog-pqr-padrao-carga-horaria' },
    );

    const dialogInstance =
      dialogRef.componentInstance as DialogPqrPadraoCargaHorariaComponent;

    dialogInstance.dadosTabelaDto = this.condicaoQualidadeStateService.getPQRCargaHorarioEnsinoPadrao();
  }

  public criaMensagemInconsistencia(): string[] {
    const mensagens: string[] = [];
    this.dadosTabela.forEach((tabela) => {
      tabela.pqr.forEach((valorPreenchido, indice) => {
        if (valorPreenchido < 3 || valorPreenchido > 12) {
          const turno: string = tabela.turnos.at(indice)?.descricao ?? '';
          mensagens.push(`Carga horária diária na etapa ${tabela.etapa.descricao} no turno ${turno} não é válida.Informe um valor de 3 a 12.`);
        }
      });
    });

    return mensagens;
  }
}

export function canDeactivateFnCargaHoraria(
  component: CargaHorariaDeEnsinoComponent,
  currentRoute: ActivatedRouteSnapshot,
  currentState: RouterStateSnapshot,
  nextState?: RouterStateSnapshot,
): Observable<boolean> | boolean {
  const mensagemInconsistencia: string[] = component.criaMensagemInconsistencia();

  if (mensagemInconsistencia.length > 0) {
    return false;
  }
  return true;
}
